import { Outlet } from "react-router-dom";
import Header from "../Header/Header";

export default function UnverifiedLayout() {
  return (
    <>
      <Header verified={false} />
      <div className="main-container main-container-kyc">
        <Outlet />
      </div>
    </>
  );
}
